import { marketingReport } from '@/api/user/user'
import { appStore, userStore } from '@/stores'
const sendEvent = (action, params = {}) => {
  // 向GA发送event事件
  params = setParams(params)
  console.log(action, params)
  // 测试环境不上报到GA
  if (import.meta.env.MODE !== 'prod') {
    return true
  }
  // eslint-disable-next-line no-undef
  gtag('event', action, params)
}
const setParams = (params) => {
  // 设置公共参数
  const commonParams = {
    country: userStore.country,
    product: appStore.productName.toLowerCase(),
    uc_source: appStore.source,
    domain: location.host.includes('updf.com') ? 'com' : 'cn',
  }
  return Object.assign({}, commonParams, params)
}
export default {
  signUp(accountType) {
    // 注册成功时上报
    sendEvent('sign_up', { type: accountType })
  },
  marketingReport(isSkip, result) {
    // 营销数据上报，上报已选择字段数量
    sendEvent('marketing_report', { isSkip, result })
  },
  signIn(accountType) {
    // 登录成功时上报
    sendEvent('sign_in', { type: accountType })
  },
  accountInput(accountType) {
    // 输入邮箱地址/手机号码点击下一步
    sendEvent('account_input', { type: accountType })
  },
  codeVerify(accountType, result) {
    // 登录检测验证码
    sendEvent('code_verify', { type: accountType, result })
  },
  codeRefresh(accountType) {
    // 重发验证码
    sendEvent('code_refresh', { type: accountType })
  },
  verifyLater() {
    // 稍后验证
    sendEvent('verify_later')
  },
  inputPassword(accountType, result) {
    // 密码登录
    sendEvent('input_password', { type: accountType, result })
  },
  setNickname(accountType, filled) {
    // 是否填写昵称
    sendEvent('set_nickname', { type: accountType, filled })
  },
  setPassword(accountType, filled) {
    // 是否填写密码
    sendEvent('set_password', { type: accountType, filled })
  },
  marketingReport(isSkip, selectAll, howToPlanUse, howHeaderUs, whatFeatureToUse, work, age) {
    // 营销数据上报，是否跳过，是否全部选择，用在何处是否勾选，在哪里听说，使用那些功能，职业，年龄
    sendEvent('user_register_info', { isSkip, selectAll, howToPlanUse, howHeaderUs, whatFeatureToUse, work, age })
  },
  jumpThirdParty(type) {
    // 跳转到第三方(只有经过index/redirect 中转的才会记录，比如Mac端的google，Facebook登录)
    sendEvent(`jump_${type}`, {})
  },
  googleOneTapPopup() {
    // 谷歌一键登录加载完成
    sendEvent('google_one_tap_popup', {})
  },
  googleOneTapClick() {
    // 谷歌一键登录点击
    sendEvent('google_one_tap_click', {})
  },
  clickGoogle() {
    // 点击谷歌登录
    sendEvent('click_google', {})
  },
  clickApple() {
    // 点击苹果登录
    sendEvent('click_apple', {})
  },
  cancelPage(plan, purchaseDays) {
    // 弹出取消订阅确认弹窗
    sendEvent('cancel_page', { plan, purchaseDays })
  },
  cancelSubscription(plan, purchaseDays) {
    // 取消页面中点击取消订阅
    sendEvent('cancel_subscription', { plan, purchaseDays })
  },
  upgradePro() {
    // 用户中心点击开通会员
    sendEvent('upgrade_pro', {})
  },
  restoreSubscription(plan, cancelDays) {
    // 用户中心点击恢复订阅
    sendEvent('restore_subscription', { plan, cancelDays })
  },
  renew() {
    // 用户中心点击立即续费
    sendEvent('renew', {})
  },
  activeGiveaway(duration, plan, registerDays) {
    // 激活赠品时，参数(赠品月份，已有plan类型，激活日期-注册日期)
    sendEvent('active_giveaway', { duration, plan, registerDays })
  },
  modifyProfile(type) {
    // 保存修改个人信息时上报
    sendEvent('modify_profile', { type })
  },
  redeemLaunch(plan) {
    // 兑换码弹窗弹起时
    sendEvent('redeem_launch', { plan })
  },
  redeemVerify(result) {
    // 检测兑换码时
    sendEvent('redeem_verify', { result })
  },
  redeem(plan, channel, result) {
    // 兑换码兑换
    sendEvent('redeem', { plan, channel, result })
  },
  deleteAccount(plan, result) {
    // 删除账号时
    sendEvent('delete_account', { plan, result })
  },
  linkManage() {
    // 进入绑定账号管理页时上报
    sendEvent('link_manage')
  },
  setPhone(result) {
    // 手机号设置成功时上报
    sendEvent('set_phone', { result })
  },
  setEmail(result) {
    // 邮箱设置成功时上报
    sendEvent('set_email', { result })
  },
  changePhone(result) {
    // 修改手机号成功上报
    sendEvent('change_phone', { result })
  },
  changeEmail(result) {
    // 修改邮箱成功上报
    sendEvent('change_email', { result })
  },
  linkWecaht(result) {
    // 绑定微信成功时上报
    sendEvent('link_wecaht', { result })
  },
  linkGoogle(result) {
    // 绑定谷歌成功时上报
    sendEvent('link_google', { result })
  },
  linkApple(result) {
    // 绑定苹果成功时上报
    sendEvent('link_apple', { result })
  },
  unlinkWechat(result) {
    // 微信解绑成功时上报
    sendEvent('unlink_wecaht', { result })
  },
  unlinkGoogle(result) {
    // 谷歌解绑成功时上报
    sendEvent('unlink_google', { result })
  },
  unlinkApple(result) {
    // 苹果解绑成功时上报
    sendEvent('unlink_apple', { result })
  },
  loginWelcomeLanch() {
    // 加载欢迎页成功时上报
    sendEvent('login_welcome_lanch')
  },
  loginWelcomeDeal() {
    // 欢迎页点击购买按钮
    sendEvent('login_welcome_deal')
  },
}
